import React from 'react';
import s from '../Product.module.css';
import Product from '../Product';
import Nav from '../../Nav/Nav';

const SaltyPastries = (props) => {
    return (
        <div className={s.container}>
            <Nav link='/makmenu' name='Солона випічка'/>
            <main className={s.main}>
                <Product name='Слойка з куркою та грибами' price='80 грн.' weight='150г.' info1='Слойка з куркою та грибами'/>
                <Product name='Трубочка з сиром та куркою' price='60 грн.'  weight='100г.' info1='Трубочка з сиром та куркою'/>
            </main>
        </div>
    )
}

export default SaltyPastries;